var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.555908 16.9231C0.555908 17.7392 0.83686 18.5218 1.33696 19.0988C1.83705 19.6759 2.51533 20 3.22257 20H21.8892C22.5965 20 23.2748 19.6759 23.7749 19.0988C24.275 18.5218 24.5559 17.7392 24.5559 16.9231V13.8462H0.555908V16.9231Z",
    fill: "#FFCD05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.555908 6.92285H24.5559V13.8459H0.555908V6.92285Z",
    fill: "#ED1F24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8892 0H3.22257C2.51533 0 1.83705 0.324175 1.33696 0.90121C0.83686 1.47824 0.555908 2.26087 0.555908 3.07692L0.555908 6.92308H24.5559V3.07692C24.5559 2.26087 24.275 1.47824 23.7749 0.90121C23.2748 0.324175 22.5965 0 21.8892 0Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.7fc7c271.svg";
export { ForwardRef as ReactComponent };